import {
   BPASS_APPLICATIONS_CITIZEN_SEARCH_CONFIG,
   BPassApplicationsCitizenSearchConfigKeyEnum,
   DASHBOARDS_CONFIG,
   DashboardsConfigKeyEnum,
   DashboardsConfigMode,
   GEO_SCRUTINY_ENGINE_CONFIG,
   GeoScrutinyEngineConfigKeyEnum,
   LEGACY_APPLICATIONS_CONFIG,
   LegacyApplicationsConfigKeyEnum,
   TDR_BANK_CONFIG,
   TDRBankConfigKeyEnum,
   TG_LOCATION_DETAILS_KML_CONFIG,
   TGLocationDetailsKmlConfigKeyEnum
} from '../constants/DynamicFeatureConstants'
import {
   BPassApplicationsCitizenSearchConfig,
   DashboardsConfig,
   GeoScrutinyEngineConfig,
   LegacyApplicationsConfig,
   TDRBankConfig,
   TGLocationDetailsKmlConfig
} from '../types/DynamicConfigTypes'

export const getDashboardsDynamicConfig = (
   getDynamicConfig: (key: string) => any
): DashboardsConfig => {
   const defaultDynamicConfig: DashboardsConfig = {
      mode: DashboardsConfigMode.ACTIVE
   }

   try {
      const config = getDynamicConfig(DASHBOARDS_CONFIG)

      if (!config) {
         return defaultDynamicConfig
      }

      const mode = config.get(DashboardsConfigKeyEnum.MODE)
      const enableAt = config.get(DashboardsConfigKeyEnum.ENABLE_AT)

      switch (mode) {
         case DashboardsConfigMode.MAINTENANCE:
            return {
               mode: DashboardsConfigMode.MAINTENANCE,
               enableAt: enableAt
            }
         case DashboardsConfigMode.ACTIVE:
            return defaultDynamicConfig
         default:
            return defaultDynamicConfig
      }
   } catch (error) {
      return defaultDynamicConfig
   }
}

export const getTDRBankDynamicConfig = (
   getDynamicConfig: (key: string) => any
): TDRBankConfig => {
   const defaultDynamicConfig: TDRBankConfig = {
      isEnabled: false
   }

   try {
      const config = getDynamicConfig(TDR_BANK_CONFIG)

      if (!config) {
         return defaultDynamicConfig
      }

      const isEnabled = config.get(TDRBankConfigKeyEnum.IS_ENABLED)

      return {
         isEnabled
      }
   } catch (error) {
      return defaultDynamicConfig
   }
}

export const getLegacyApplicationsDynamicConfig = (
   getDynamicConfig: (key: string) => any
): LegacyApplicationsConfig => {
   const defaultDynamicConfig: LegacyApplicationsConfig = {
      isEnabled: false,
      userIds: []
   }

   try {
      const config = getDynamicConfig(LEGACY_APPLICATIONS_CONFIG)

      if (!config) {
         return defaultDynamicConfig
      }

      const isEnabled =
         config.get(LegacyApplicationsConfigKeyEnum.IS_ENABLED) ?? false
      const userIds = config.get(LegacyApplicationsConfigKeyEnum.USER_IDS) ?? []

      return {
         isEnabled: Boolean(isEnabled),
         userIds: Array.isArray(userIds) ? userIds : []
      }
   } catch (error) {
      return defaultDynamicConfig
   }
}

export const getBPassApplicationsCitizenSearchDynamicConfig = (
   getDynamicConfig: (key: string) => any
): BPassApplicationsCitizenSearchConfig => {
   const defaultDynamicConfig: BPassApplicationsCitizenSearchConfig = {
      isEnabled: false
   }

   try {
      const config = getDynamicConfig(BPASS_APPLICATIONS_CITIZEN_SEARCH_CONFIG)

      if (!config) {
         return defaultDynamicConfig
      }

      const isEnabled =
         config.get(BPassApplicationsCitizenSearchConfigKeyEnum.IS_ENABLED) ??
         false

      return { isEnabled: Boolean(isEnabled) }
   } catch (error) {
      return defaultDynamicConfig
   }
}

export const getTGLocationDetailsKmlConfig = (
   getDynamicConfig: (key: string) => any
): TGLocationDetailsKmlConfig => {
   const defaultDynamicConfig: TGLocationDetailsKmlConfig = {
      tilesetId: '',
      accessToken: ''
   }

   try {
      const config = getDynamicConfig(TG_LOCATION_DETAILS_KML_CONFIG)

      if (!config) {
         return defaultDynamicConfig
      }

      const tilesetId =
         config.get(TGLocationDetailsKmlConfigKeyEnum.TILESET_ID) ?? ''
      const accessToken =
         config.get(TGLocationDetailsKmlConfigKeyEnum.ACCESS_TOKEN) ?? ''

      return { tilesetId, accessToken }
   } catch (error) {
      return defaultDynamicConfig
   }
}

export const getGeoScrutinyEngineDynamicConfig = (
   getDynamicConfig: (key: string) => any
): GeoScrutinyEngineConfig => {
   const defaultConfig: GeoScrutinyEngineConfig = {
      tilesetId: '',
      accessToken: '',
      enableGeoScrutinyEngine: false
   }

   try {
      const config = getDynamicConfig(GEO_SCRUTINY_ENGINE_CONFIG)

      if (!config) {
         return defaultConfig
      }

      const tilesetId =
         config.get(GeoScrutinyEngineConfigKeyEnum.TILESET_ID) ?? ''
      const accessToken =
         config.get(GeoScrutinyEngineConfigKeyEnum.ACCESS_TOKEN) ?? ''
      const enableGeoScrutinyEngine =
         config.get(
            GeoScrutinyEngineConfigKeyEnum.ENABLE_GEO_SCRUTINY_ENGINE
         ) ?? false

      return { tilesetId, accessToken, enableGeoScrutinyEngine }
   } catch (error) {
      return defaultConfig
   }
}
